

$(".navbar-toggler").click(function(){

  $(".navbar-toggler").toggleClass("showtoggle");

});



$(".closed").click(function(){

  $(".navbar-collapse").removeClass("show");

});   


    $(".jobsbtn a").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


    $(".searh_bx a").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


$(window).scroll(function () {
    if (window.location.pathname !== "/") {
        return;
    }

    var $header = $(".header_sec");
    var scroll = $(window).scrollTop();

    if (scroll >= 50) {
        $header.addClass("fixed").removeClass("normalMenu");
    } else {
        $header.removeClass("fixed").addClass("normalMenu");
    }
});

$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 150) {
        $(".chats").addClass("actv");

    } else {
        $(".chats").removeClass("actv");
    }
   if (scroll >= 250) {
        $(".backTop").addClass("actv");

    } else {
        $(".backTop").removeClass("actv");
    } 
});


$(document).ready(function() {
var owl = $('.oppcaro.owl-carousel');
    owl.owlCarousel({
    margin:20,
    dots: true,
    dotsEach: false,
        autoplay: true,
        autoplayTimeout: 2300,
        autoplayHoverPause: true,
    nav: false,
    loop: true,
    responsive: {
      1: {	
        items: 1,
        stagePadding: 40,
        autoplay: true,
        dots: false,
        margin:10,
      },
      475: {	
        items: 1,
        stagePadding: 30,
        autoplay: true,
        dots: false,
        margin:10,
      },
      600: {	
        items: 2,
        stagePadding: 50,
        autoplay: true,
        dots: false,
        margin:10,
      },
      768: {
        items: 2,
      },         
      992: {
        items: 2,
      },
      1200: {
        items: 3,
      }
    }
  });
});

$(document).ready(function() {
var owl = $('.oppcaro4.owl-carousel');
  owl.owlCarousel({
    margin:20,
    dots: true,
    dotsEach: false,
    autoplay: false,
    nav: false,
    loop: true,
    responsive: {
      1: {	
        items: 1,
        stagePadding: 40,
        autoplay: true,
        dots: false,
        margin:10,
      },
      475: {	
        items: 2,
        stagePadding: 20,
        autoplay: true,
        dots: false,
        margin:10,
      },
      600: {	
        items: 2,
        stagePadding: 50,
        autoplay: true,
        dots: false,
        margin:10,
      },
      768: {
        items: 2,
      },         
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      }
    }
  });
});


$(document).ready(function() {
var owl = $('.spacilCaro.owl-carousel');
  owl.owlCarousel({
    margin:20,
    dots: true,
    dotsEach: false,
    autoHeight: true,
    autoplay: true,
    nav: false,
    loop: true,
    responsive: {
      1: {	
        items: 1
      },
      700: {
        items: 2
      },
      1200: {
        items: 2
      }
    }
  });
});



$(document).ready(function() {
var owl = $('.pepleCaro.owl-carousel');
  owl.owlCarousel({
    margin:20,
    dots: true,
    dotsEach: false,
    autoHeight: false,
    autoplay: false,
    nav: false,
    loop: true,
    responsive: {
      1: {	
        items: 1,
        stagePadding: 40,
        autoplay: true,
        dots: false,
        margin:10,
      },
      475: {	
        items: 1,
        stagePadding: 30,
        autoplay: true,
        dots: false,
        margin:10,
      },
      600: {	
        items: 2,
        stagePadding: 50,
        autoplay: true,
        dots: false,
        margin:10,
      },
      768: {
        items: 2
      },         
      992: {
        items: 3
      },
      1200: {
        items: 4
      }
    }
  });
});

$(document).ready(function() {
var owl = $('.trastCaro.owl-carousel');
  owl.owlCarousel({
    margin:10,
    dots: false,
    dotsEach: false,
    autoHeight: false,
      autoplay: true,
      autoplayTimeout: 2300,
      autoplayHoverPause: true,
    nav: false,
    loop: true,
    responsive: {
      1: {	
        items: 1
      },
      400: {	
        items: 2
      },
      575: {	
        items: 2
      },
      640: {	
        items: 3
      },
      768: {
        items: 2
      },         
      992: {
        items: 3
      },
      1200: {
        items: 4
      }
    }
  });
});






$(document).ready(function() {
var owl = $('.newscaro.owl-carousel');
  owl.owlCarousel({
    margin:15,
    dots: false,
    dotsEach: false,
    nav: false,
    loop: true,
    responsive: {
      1: {	
        items: 1,
        stagePadding: 40,
        autoplay: true,
        dots: false,
        margin:10,
      },
      475: {	
        items: 1,
        stagePadding: 30,
        autoplay: true,
        dots: false,
        margin:10,
      },
      600: {	
        items: 2,
        stagePadding: 50,
        autoplay: true,
        dots: false,
        margin:10,
      },
      768: {
        items: 2,
        margin:20,
      },         
      992: {
        items: 2,
        margin:20,
      },
      1200: {
        items: 3,
        margin:20,
      }
    }
  });
});
jQuery(document).ready(function(){
	$objWindow = $(window);
	$('div[data-type="background"]').each(function(){
		var $bgObj = $(this);
		$(window).scroll(function() {
			var yPos = -($objWindow.scrollTop() / $bgObj.data('speed')); 
           
			var coords = '100% '+ yPos + 'px';
            // Animate the background
			 $bgObj.css({ backgroundPosition: coords });
           
		});
		
	});
});


$(document).ready(function() {
  var owl = $('.teamCaro.owl-carousel');
  owl.owlCarousel({
    margin:24,
    dots: false,
    autoHeight: false,
    autoplay: false,
    nav: true,
    loop: false,
    rewind: true, // 👈 IMPORTANT
    navText: [
      '<i class="fa-solid fa-angle-left"></i>',
      '<i class="fa-solid fa-angle-right"></i>'
    ],
    responsive: {
      0: { items: 1, stagePadding: 10,loop: true, },   // 👈 START FROM 0
      340: { items: 1, stagePadding: 10,loop: true, },   // 👈 START FROM 0
      400: { items: 1, stagePadding: 10,loop: true, },
      575: { items: 2,stagePadding: 30,loop: true, },
      640: { items: 2,stagePadding: 30,loop: true,  },
      768: { items: 2, dots: true, },
      992: { items: 2, dots: true, },
      1200: { items: 3, dots: true, }
    }
  });
});

$('.teamCaro').on('changed.owl.carousel', function(event) {
  var carousel = event.relatedTarget;
  var index = carousel.current();

  if (index === 0) {
    $('.teamCaro .owl-prev').hide();  // first slide → hide prev
  } else {
    $('.teamCaro .owl-prev').show();  // other slides → show prev
  }
});

//$(document).ready(function () {
//    $('.counter').countUp();
//});

$(document).ready(function () {
    $('.counter').each(function () {
        const num = parseInt($(this).text(), 10);

        $(this).countUp({
            time: num === 5 ? 900 : 1200
        });
    });
});


















